import React, { useEffect, ReactNode, useContext, ReactElement } from 'react';
import HeaderContext from './context/HeaderContext';

/**
 * Hook that collaspes dropdowns and menu if clicked outside element
 */
function useOutsideClick(): void {
  const { setShowMenu } = useContext(HeaderContext);
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent): void => {
      const { tagName } = event.target as Element;
      if (tagName === 'NAV' || tagName === 'DIV') {
        setShowMenu(false);
      }
    };

    document.addEventListener('click', handleOutsideClick, false);
    return (): void => {
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, [setShowMenu]);
}

function OutsideClick(props: { children: ReactNode }): ReactElement {
  useOutsideClick();
  const { children } = props;
  return <div>{children}</div>;
}

export default OutsideClick;
